import Vue from 'vue';
import VueRouter from 'vue-router';
import Register from '@/views/Register.vue';
import Login from '@/views/Login.vue';
import store from "../store";
import OnlineCourses from '@/views/OnlineCourses.vue';
import CourseDetail from '@/views/CourseDetail.vue';
import CheckoutPage from '@/views/CheckoutPage.vue';
import CheckoutSuccess from '@/views/CheckoutSuccess.vue';
import LiveTraining from '@/views/LiveTraining.vue';
import MyCourses from '@/views/MyCourses.vue';
import ViewCourse from '@/views/ViewCourse.vue';
import TrainingDetail from '@/views/TrainingDetail.vue';
import LiveCourses from '@/views/LiveCourses.vue';
import MyRequests from '@/views/MyRequests.vue';
import MyProfile from '@/views/MyProfile.vue';
import Home from '@/views/Home.vue';
import Category from '@/views/Category.vue';
import TermsAndConditions from '@/views/TermsAndConditions.vue';
import PrivacyPolicy from '@/views/PrivacyPolicy.vue';

Vue.use(VueRouter);
const routes = [
    {
        path: '',
        redirect: '/home',
    },
    {
        path: '/register',
        name: 'register',
        component: Register,
        meta: { guest: true },
    },
    {
        path: '/home',
        name: 'home',
        component: Home,
        meta: { guest: true },
    },
    {
        path: '/login',
        name: 'login',
        component: Login,
        meta: { guest: true },
    }, 
    {
        path: '/category',
        name: 'category',
        component: Category,
        meta: { guest: true },
    },
    {
        path: '/online-courses/:id',
        name: 'onlineCourses',
        component: OnlineCourses,
        meta: { guest: true },
    },
    {
        path: '/course-detail/:id',
        name: 'coursedetail',
        component: CourseDetail,
        meta: { guest: true },
    },
    {
        path: '/checkout/:id',
        name: 'checkout',
        component: CheckoutPage,
        meta: { requiresAuth: true },
    },
    {
        path: '/checkout-success',
        name: 'CheckoutSuccess',
        component: CheckoutSuccess,
        meta: { requiresAuth: true },
    },
    {
        path: '/live-training',
        name: 'LiveTraining',
        component: LiveTraining,
        meta: { guest: true },
    },
    {
        path: '/my-courses',
        name: 'MyCourses',
        component: MyCourses,
        meta: { requiresAuth: true },
    },
    {
        path: '/live-courses',
        name: 'LiveCourses',
        component: LiveCourses,
        meta: { guest: true },
    },
    {
        path: '/my-requests',
        name: 'MyRequests',
        component: MyRequests,
        meta: { requiresAuth: true },
    },
    {
        path: '/my-profile',
        name: 'MyProfile',
        component: MyProfile,
        meta: { requiresAuth: true },
    },
    {
        path: '/view-course/:id',
        name: 'ViewCourse',
        component: ViewCourse,
        meta: { requiresAuth: true },
    },
    {
        path: '/free-course/:id',
        name: 'FreeCourse',
        component: ViewCourse,
        meta: { requiresAuth: true },
    },
    {
        path: '/training-detail/:id',
        name: 'trainingdetail',
        component: TrainingDetail,
        meta: { guest: true },
    },
    {
        path: '/terms-conditions',
        name: 'termsconditions',
        component: TermsAndConditions,
        meta: { guest: true },
    },
    {
        path: '/privacy-policy',
        name: 'privacypolicy',
        component: PrivacyPolicy,
        meta: { guest: true },
    },
]
const router = new VueRouter({
    mode: "history",
    base: process.env.BASE_URL,
    routes,
    scrollBehavior(to, from, savedPosition) {
        // if a saved position exists (useful for browser back/forward)
        if (savedPosition) {
            return savedPosition;
        } else {
            // Scroll to top of the page for new route
            return { x: 0, y: 0 };
        }
    },
});

router.beforeEach((to, from, next) => {
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        if (store.getters.isAuthenticated) {
            next();
        } else {
            // if (from.name === 'coursedetail' && to.name === 'checkout') {
            //     next(`/login?redirectTo=${encodeURIComponent(to.fullPath)}`);
            // } else {
            //     next("/login");
            // }
            next(`/login?redirectTo=${encodeURIComponent(to.fullPath)}`);
        }
    } else {
        next();
    }
});


// router.beforeEach((to, from, next) => {
//     if (to.matched.some((record) => record.meta.guest)) {
//         if (store.getters.isAuthenticated) {
//             next("/home");
//             return;
//         }
//         next();
//     } else {
//         next();
//     }
// });

export default router;
